import { ProductModel } from '@/types/model/Product'

interface ProductDetailsTabProps {
  product: ProductModel.Product
}

export const ProductDetailsTab = ({ product }: ProductDetailsTabProps) => {
  return (
    <div className="space-y-5">
      <section className="space-y-2">
        <h3 className="text-heading-md text-ink">Description</h3>
        <div
          className="prose prose-sm max-w-none text-text-2"
          dangerouslySetInnerHTML={{ __html: product.description || 'No description available.' }}
        />
      </section>

      {product.delivery_return_policy && (
        <section className="space-y-2 border-t border-border-subtle pt-5">
          <h3 className="text-heading-md text-ink">Delivery and return policy</h3>
          <div
            className="prose prose-sm max-w-none text-text-2"
            dangerouslySetInnerHTML={{ __html: product.delivery_return_policy }}
          />
        </section>
      )}

      <section className="grid grid-cols-1 gap-5 border-t border-border-subtle pt-5 sm:grid-cols-2">
        <div className="space-y-1">
          <h3 className="text-xs font-medium text-text-2">SEO meta title</h3>
          <p className="text-sm text-ink">{product.meta_title || 'N/A'}</p>
        </div>
        <div className="space-y-1">
          <h3 className="text-xs font-medium text-text-2">SEO meta description</h3>
          <p className="whitespace-pre-wrap text-sm text-ink">{product.meta_description || 'N/A'}</p>
        </div>
      </section>
    </div>
  )
}
